// Shared styling for the environment badge shown in the login footer (landing.tsx)
// and the sidebar footer (sidebar.tsx). The env itself is still determined by each
// caller as (import.meta.env.VITE_APP_ENV || 'local').toLowerCase().
//
// Production is intentionally a calm green (not red) so it doesn't read like an error.
export interface EnvBadgeConfig {
  label: string;
  /** Text colour class for the label. */
  color: string;
  /** Text colour class for the sidebar's label (the sidebar's original hues). */
  sidebarColor: string;
  /** Background + border classes for the pill (sidebar uses this; landing does not). */
  bg: string;
  /** Background colour class for the status dot. */
  dot: string;
}

export const envConfig: Record<string, EnvBadgeConfig> = {
  local: { label: 'LOCAL', color: 'text-emerald-500', sidebarColor: 'text-emerald-400', bg: 'bg-emerald-500/10 border-emerald-500/20', dot: 'bg-emerald-400' },
  qa: { label: 'QA', color: 'text-blue-500', sidebarColor: 'text-blue-400', bg: 'bg-blue-500/10 border-blue-500/20', dot: 'bg-blue-400' },
  uat: { label: 'UAT', color: 'text-green-500', sidebarColor: 'text-green-500', bg: 'bg-green-500/10 border-green-500/20', dot: 'bg-green-400' },
  staging: { label: 'STAGING', color: 'text-amber-500', sidebarColor: 'text-amber-400', bg: 'bg-amber-500/10 border-amber-500/20', dot: 'bg-amber-400' },
  production: { label: 'PRODUCTION', color: 'text-green-600', sidebarColor: 'text-green-400', bg: 'bg-green-500/10 border-green-500/20', dot: 'bg-green-500' },
};

/** Look up badge styling for an env, falling back to `local` for unknown values. */
export function getEnvBadgeConfig(env: string): EnvBadgeConfig {
  return envConfig[env] || envConfig.local;
}
